import React, { useState } from 'react'
import "./services.css"

const Services = () => {

    const [toggleState, setToggleState] = useState(0);
    const toggleTab = (index) => {
        setToggleState(index)
    }

  return (
    <section className="services section" id="services">
        <h2 className="section__title">
            Services
        </h2>
        <span className="section__subtitle">
            What I can do for you!
        </span>

        <div className="services__container container grid">
            <div className="services__content">
                <div>
                    <i className='uil uil-browser services__icon'></i>
                    <h3 className="services__title">
                        Web <br/> Developer
                    </h3>
                </div>

                <span className="services__button" onClick={() => toggleTab(1)}>
                    View More <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 1 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">
                            Web Developer
                        </h3>

                        <p className="services__modal-description">
                            Service with over a year's worth of providing quality work to clients and companies
                        </p>

                        <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                    I develop web applications using the MERN stack.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                    I update and upgrade sites
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                    I create low end to high end sites
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                    I do proper SE-Optimizations
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                    I just deliver
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>




            <div className="services__content">
                <div>
                    <i className='uil uil-shopping-bag services__icon'></i>
                    <h3 className="services__title">
                        E-commerce <br/> Development
                    </h3>
                </div>

                <span onClick={() => toggleTab(2)} className="services__button">
                    View More <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 2 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">
                            E-commerce Development
                        </h3>

                        <p className="services__modal-description">
                        Experience Delivering Quality Solutions to Clients and Companies for Over a Year
                        </p>

                        <ul className="services__modal-services grid">
                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I specialize in crafting e-commerce solutions using the MERN stack.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I excel at revamping and enhancing e-commerce websites.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I design e-commerce platforms ranging from basic to high-end.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I implement effective SEO optimizations for enhanced online visibility.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                My commitment is to consistently deliver exceptional results.
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>




            <div className="services__content">
                <div>
                    <i className='uil uil-users-alt services__icon'></i>
                    <h3 className="services__title">
                        Consultation & <br/> Training
                    </h3>
                </div>

                <span onClick={() => toggleTab(3)} className="services__button">
                    View More <i className="uil uil-arrow-right services__button-icon"></i>
                </span>

                <div className={toggleState === 3 ? "services__modal active-modal" : "services__modal"}>
                    <div className="services__modal-content">
                        <i onClick={() => toggleTab(0)} className="uil uil-times services__modal-close"></i>
                        <h3 className="services__modal-title">
                            Consultation &  Training
                        </h3>

                        <p className="services__modal-description">
                        With over a year of experience delivering top-notch solutions to clients and companies, I specialize in providing expert guidance and training in web development. As a Web Development Consultant and Trainer, my services encompass:
                        </p>

                        <ul className="services__modal-services grid">

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I will assist you in optimizing your web projects by providing recommendations and strategies for updating and upgrading your websites to meet modern standards and user expectations.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                My training programs cater to individuals and organizations at all levels, from beginners looking to create basic web pages to professionals aiming for high-end, feature-rich websites.
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I will guide you on proper Search Engine Optimization (SEO) techniques
                                </p>
                            </li>

                            <li className="services__modal-service">
                                <i className="uil uil-check-circle services-modal-icon"></i>
                                <p className="services__modal-info">
                                I am committed to delivering exceptional service and comprehensive training
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}

export default Services